import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { task } from 'ember-concurrency';

import { query } from 'umg-ember-backend/data/builders/umg-rest';

import config from '../config/environment';

export default class DataService extends Service {
  // Services
  @service fetch;
  @service intl;
  @service store;

  // Defaults
  @tracked assetFolders = [];
  @tracked assetFoldersGrouped = [];
  contributorCategories = [];
  externalReferenceServices = [];
  partnerTypes = [
    { value: 'Buy', label: 'Buy' },
    { value: 'Download', label: 'Download' },
    { value: 'Streaming', label: 'Streaming' },
  ];

  // Constructor
  constructor() {
    super(...arguments);

    this.contributorCategories = this.getCategories({
      'filter[type]': 'CONTRIB_FUNC',
    });
    this.externalReferenceServices = this.getCategories({
      'filter[type]': 'EXT_SERVICE',
    });

    this.getAssetFolders.perform();
  }

  // Functions
  async getCategories(customFilter = {}) {
    const queryObject = {
      'filter[cmsState]': 2,
      ...customFilter,
    };

    const { content } = await this.store.request(
      query('category', {
        ...queryObject,
        limit: config.API.limit ?? 1000,
        locale: this.intl.primaryLocale,
      }),
    );

    return content.data.slice().sort((a, b) => a.name > b.name);
  }

  // Tasks
  getAssetFolders = task({ restartable: true }, async () => {
    let folders = await this.fetch.request('/config/assetFolders');
    let groups = [];

    folders = folders.map((folder) => {
      return {
        value: folder.id,
        label: folder.name,
        parent: folder.parent,
      };
    });

    this.assetFolders = folders;

    folders.forEach((folder) => {
      let parent = folders.find((f) => f.value === folder.parent);
      let group = groups.find((f) => f.value === folder.parent);

      if (!parent) {
        return;
      }

      if (group) {
        group.children.push(folder);
      } else {
        groups.push({
          value: parent.value,
          label: parent.label,
          children: [folder],
        });
      }
    });

    this.assetFoldersGrouped = groups;
  });
}
